import { IApplicationState } from '../../types/redux';

export function selectMinZoom(state: IApplicationState): number {
  return state.infrastructure.config.minZoom;
}
